/**
 * Toast Notification System
 * Handles display and dismissal of toast notifications
 */
(function ($) {
	document.addEventListener('DOMContentLoaded', function () {
		// Find all toast notifications
		let toasts = document.querySelectorAll('.js-notifications-alert');
		let delay = 100;

		// Stagger the animations for multiple toasts
		toasts.forEach((toast, index) => {
			// Animate entrance with staggered delay
			setTimeout(() => {
				toast.classList.add('visible');
			}, delay + (index * 200));
		});
	});

	/**
	 * Dismisses a toast notification with animation
	 * @param {HTMLElement} toast - The toast element to dismiss
	 */
	window.dismissToast = function(toast) {
		// Mark the toast as closing for accessibility
		toast.setAttribute('aria-hidden', 'true');
		toast.classList.add('closing');

		// Start the exit animation
		toast.classList.remove('visible');

		// After the exit animation completes
		setTimeout(() => {
			// Set the current height to enable animation
			toast.style.height = toast.offsetHeight + 'px';
			toast.style.overflow = 'hidden';

			// Force a reflow to ensure the height is applied
			toast.offsetHeight;

			// Animate to zero height
			toast.style.height = '0';
			toast.style.marginBottom = '0';
			toast.style.paddingTop = '0';
			toast.style.paddingBottom = '0';

			// Remove the element after the height animation
			setTimeout(() => {
				toast.remove();
			}, 300);
		}, 300);
	}

	/**
	 * Handler for close button clicks
	 * @param {HTMLElement} closeButton - The close button that was clicked
	 */
	window.closeToast = function(closeButton) {
		const toast = closeButton.closest('.js-notifications-alert');
		dismissToast(toast);
	}
})(jQuery);
